// extracted by mini-css-extract-plugin
export default {"footer":"RelativeInfoSidePage-module--footer--e9aJS","footerLeft":"RelativeInfoSidePage-module--footerLeft--NAuFy"};